<div [formGroup]="formGroup" class="container">
  @for (
    item of formGroup['controls']['keyValueArray']['controls'];
    track item;
    let i = $index;
    let last = $last;
    let first = $first;
    let count = $count
  ) {
    <div formArrayName="keyValueArray">
      <div [formGroupName]="i" class="mb-3 row">
        <div class="col-1">
          @if (last) {
            <button
              class="btn btn-link float-right"
              (click)="addKeyValueFormGroupToForm()"
              (keydown.enter)="addKeyValueFormGroupToForm()">
              <i class="fa fa-plus fa-lg"></i>
            </button>
          }
        </div>
        <div class="col-1">
          @if (count !== 1) {
            <button
              class="btn btn-link float-right"
              (click)="removeKeyValueFormGroupFromForm(i)"
              (keydown.enter)="removeKeyValueFormGroupFromForm(i)">
              <i class="fa fa-remove fa-lg"></i>
            </button>
          }
        </div>
        <div class="col-5">
          <input class="form-control" type="text" formControlName="key" />
          @if (item.get('key').invalid && item.get('key').dirty) {
            <small class="text-danger">{{
              parsedConfig.keyValidatorErrorMessage
            }}</small>
          }
        </div>
        <div class="col-5">
          <input class="form-control" type="text" formControlName="value" />
          @if (item.get('value').invalid && item.get('value').dirty) {
            <small class="text-danger">{{
              parsedConfig.valueValidatorErrorMessage
            }}</small>
          }
        </div>
      </div>
    </div>
  }
</div>
